import React from 'react';
import PropTypes from 'prop-types';
import {isEmpty as _isEmpty} from 'lodash';
import {Popup} from 'semantic-ui-react';

import {coverage} from '@modules/events/utils/EventsTabsLayout/Details/EventDetails/fields/column1/coverage';
import {getClipProvidersNames} from '@modules/events/utils/eventSchedule';
import {FormattedClipProviders} from '@modules/events/utils/ClipProvidersHelper';

const getClipProvidersContent = (clip_providers) => {
    if (_isEmpty(clip_providers)) return null;

    return <FormattedClipProviders providers={getClipProvidersNames(clip_providers)} />;
};

export const CoverageWithClipProviders = ({products, clip_providers}) => {
    const hasClipProviders = !_isEmpty(clip_providers);
    const coverageText = coverage(products);
    const clipProvidersContent = getClipProvidersContent(clip_providers);

    if (!hasClipProviders) return coverageText;

    return (
        <Popup
            className='clip-provider-popup'
            trigger={<span>{coverageText}</span>}
            position='top left'
            wide='very'
            hoverable
        >
            {clipProvidersContent}
        </Popup>
    );
};

CoverageWithClipProviders.propTypes = {
    products: PropTypes.array,
    clip_providers: PropTypes.array,
};

CoverageWithClipProviders.defaultProps = {
    products: [],
    clip_providers: [],
};
